import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../../state/state.types';

const mapState = ({ queryParams }: StateType) => ({
  originalQueryKey: queryParams.originalQueryKey,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
